"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./Dropdown.css");

var _DropdownDumb = _interopRequireDefault(require("./DropdownDumb"));

var _useDropdownState2 = _interopRequireDefault(require("./useDropdownState"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
Smart dropdown, that handles its own state management
*/
function DropdownSmart(_ref) {
  var openProp = _ref.open,
      children = _ref.children,
      onToggle = _ref.onToggle,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["open", "children", "onToggle"]);

  var _useDropdownState = (0, _useDropdownState2["default"])({
    open: openProp,
    onToggle: onToggle
  }),
      open = _useDropdownState.open,
      componentRef = _useDropdownState.componentRef,
      toggleDropdown = _useDropdownState.toggleDropdown;

  return /*#__PURE__*/_react["default"].createElement(_DropdownDumb["default"], _extends({
    open: open
  }, otherProps, {
    componentRef: componentRef,
    onToggle: toggleDropdown
  }), children);
}

DropdownSmart.propTypes = {
  /** whether dropdown is open on initial render */
  open: _propTypes["default"].bool,

  /** event listener for when dropdown is toggled; passes open state as parameter */
  onToggle: _propTypes["default"].func
};
DropdownSmart.defaultProps = {
  onToggle: function onToggle() {
    return null;
  },
  open: false
};
var _default = DropdownSmart;
exports["default"] = _default;